import React from "react";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

interface UnsaveConfirmPopupProps {
  open: any;
  onClose: any;
  onOtherAction: any;
  confirmContent: any;
}
const UnsaveConfirmPopup: React.FC<UnsaveConfirmPopupProps> = ({
  open,
  onClose,
  onOtherAction,
  confirmContent,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="bg-white rounded-2xl p-6 min-w-[18.5rem] max-w-[18.5rem] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
        <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2 mb-8">
          {confirmContent}
        </h2>
        <div className="flex items-center justify-center gap-8">
          <CustomButton
            type="button"
            onClick={onClose}
            variant="text"
          >
            キャンセル
          </CustomButton>
          <CustomButton
            customStyle="!w-[120px]"
            type="button"
            variant="outline"
            onClick={onOtherAction}
            size="md"
          >
            終了する
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default UnsaveConfirmPopup;
